import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { lg, md, xl } from '../common';
import { getRadioGroupValue, onRadioGroupValueChange } from '../lib/radioGroup';

function changePrice(card, cycle) {
  if (!['monthly', 'annually'].includes(cycle)) return;

  const number = card.querySelector('.pricing__price-num');
  if (!number) return;

  const labelEl = card.querySelector('.pricing__cycle-label');
  if (labelEl) {
    const label = cycle === 'monthly' ? 'month' : 'year';
    labelEl.textContent = label;
  }

  const price = card.querySelector('.pricing__price');
  const to =
    cycle === 'monthly'
      ? number.dataset.priceMonthly
      : number.dataset.priceAnnually;

  const tl = gsap.timeline();
  tl.fromTo(price, { opacity: 0 }, { opacity: 1, duration: 0.5 });
  tl.counter(
    number,
    {
      end: parseInt(to, 10),
      increment: 1,
      duration: 1,
    },
    '<',
  );

  const texts = card.querySelectorAll('[data-text-monthly]');
  texts.forEach((text) => {
    const monthly = text.dataset.textMonthly;
    const annually = text.dataset.textAnnually;
    const to = cycle === 'monthly' ? monthly : annually;
    console.log({ monthly, annually, to });
    text.textContent = to;
  });
}

export function initPricing() {
  const parent = document.querySelector('.pricing');
  if (!parent) return;

  new Swiper('.pricing__swiper', {
    modules: [Pagination],
    slidesPerView: 'auto',
    spaceBetween: 24,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      [md]: {
        slidesPerView: 2,
      },
      [lg]: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
      [xl]: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  });

  const cards = parent.querySelectorAll('.pricing__card');
  const radios = parent.querySelectorAll('.btn-selector__input');
  let cycle = getRadioGroupValue(radios);

  onRadioGroupValueChange(radios, (value) => {
    cycle = value;
    cards.forEach((card) => changePrice(card, cycle));
  });

  ScrollTrigger.create({
    trigger: '.pricing__swiper',
    start: 'top bottom-=200px',
    onEnter: () => {
      cards.forEach((card) => changePrice(card, cycle));
    },
  });
}
